export default {
  GET_FINANCIAL_INSTITUTIONS_QUERY_SERVICE: Symbol.for('GET_FINANCIAL_INSTITUTIONS_QUERY_SERVICE'),
  FINANCIAL_INSTITUTION_REPOSITORY: Symbol.for('FINANCIAL_INSTITUTION_REPOSITORY'),
  ONBOARDING_FINANCIAL_INSTITUTION_STATE_MANAGER: Symbol.for('ONBOARDING_FINANCIAL_INSTITUTION_STATE_MANAGER'),
};
